<template>
    <LTileLayer :url="url" :attribution="attribution" :visible="visible" :options="{maxNativeZoom: 19, maxZoom: 21}" key="ortho" name="Letecká" layer-type="base"/>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {LTileLayer} from '@vue-leaflet/vue-leaflet';

const apiKey = process.env.VUE_APP_API_KEY_MAPY_CZ;

export default defineComponent({
    components: {LTileLayer},
    props: {
        visible: {
            type: Boolean,
            default: true,
        },
    },
    setup() {
        const url = 'https://api.mapy.cz/v1/maptiles/aerial/256/{z}/{x}/{y}?apikey=' + apiKey;
        const attribution = '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>';

        return {url, attribution};
    },
});
</script>
